import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'iw-dot-pulse',
  styleUrl: './dot-pulse.component.scss',
  template: '<div class="loader-dot"></div>',
  host: {
    '[class]': 'size()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotPulseComponent {
  size = input<'m' | 'l'>('m');
}
